/**
 * Shared formatting helpers for the harvest monitoring reports
 * (per-location and per-foreman views).
 */

import React from 'react';
import { format } from 'date-fns';
import { id as localeId } from 'date-fns/locale';

export const formatDate = (dateString: string): string => {
    try {
        return format(new Date(dateString), 'dd/MM/yyyy', { locale: localeId });
    } catch {
        return dateString;
    }
};

export const formatNumber = (num: number): string => {
    if (num === 0 || num === null || num === undefined) {
        return '-';
    }
    return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(num);
};

export const formatInteger = (num: number): string => {
    if (num === 0 || num === null || num === undefined) {
        return '-';
    }
    return new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(num);
};

export const formatNumberWithLineBreak = (text: string): React.ReactNode => {
    if (!text) return text;
    const parts = text.split('/');

    if (parts.length <= 2) {
        return text;
    }

    return (
        <>
            {parts[0]}/{parts[1]}/<br />
            {parts.slice(2).join('/')}
        </>
    );
};
